import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';
import { Box } from '@mui/material';

// Components
import InventoryOwnerAutoComplete from '../../components/InventoryOwnerAutoComplete.connector';
import Buttons from '../../components/Buttons';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const LastStep1 = ({ loading, next, prev }) => {
  const {
    data,
    data: { currentAffiliate, inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const selectLast = val => {
    const update = {
      ...data,
      inventoryOwners: [val],
      loadLocations: true,
      loadProducts: true,
      locations: [],
      products: [],
    };
    setData(update);
  };

  const lastInventoryOwner = inventoryOwners[inventoryOwners.length - 1]?.companyCustomerIdName;

  return (
    <>
      <Box
        sx={{
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <InventoryOwnerAutoComplete
          currentAffiliate={currentAffiliate}
          onChange={selectLast}
          selected={lastInventoryOwner}
          title="Which Inventory Owner should be last?"
        />
      </Box>
      <Buttons
        disabled={R.isNil(lastInventoryOwner)}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

LastStep1.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default LastStep1;
